import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.5117 8.94775L12.3034 3.44775L9.09505 8.94775L3.13672 10.7811L7.26172 14.9061L5.88672 21.7811L12.3034 18.8863L18.7201 21.7811L17.3451 14.9061L21.4701 10.7811L15.5117 8.94775Z",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }